const formatMoney = amount => {
  const roundNumber = (num, dec) => Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
  if (amount) {
    // Make sure "amount" is in cents
    if (String(amount).indexOf('.') > -1) {
      amount = Number(amount) * 100;
    }
    amount = (amount / 100).toFixed(2);
  } else {
    amount = 0.00;
  }
  return `£${amount}`;
};
export default formatMoney;